export default class newsFeed {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/dashboard/widgets/news-feed.html'),
            replace: true,
            controller: FeedCtrl,
            controllerAs: 'feed'
        }
    }
};

class FeedCtrl {
    constructor(Dashboard) {
        this.dashboardRepo = Dashboard;

        this.showFeed = true;

        this.dashboardRepo.getFeedAndPlugins().then((result) => {
            this.newsFeed = angular.fromJson(result.feed).data;
            this.availablePlugins = result.plugins;
        });
    }

    toggle() {
        this.showFeed = ! this.showFeed;
    };
}
